import { MdEuro, MdOutlineShoppingBasket, MdAnalytics } from 'react-icons/md';
import { useEffect, useState } from 'react';
import { TbMoneybag, TbPigMoney } from 'react-icons/tb';

import MiniStatistics from 'components/card/MiniStatistics';
import AverageBasket from './components/averageBasket';
import OrdersLines from './components/OrdersLines';
import BenefitLines from './components/BenefitLines';
import TopCustomersMap from './components/TopCustomersMap';
import VolumeTable from './components/volumeTable';
import { CONFIG } from 'variables/config';
import axios from 'axios';
import ChartBar3Period from '../../seller/dashboard/components/ChartBar3Period';

const ReportingDashboard = () => {
    const [kpis, setKpis] = useState<any>(null);

    const initSellerKPI = () => {
        axios
            .get(`${CONFIG.apiUrl}/user/buyer-kpi`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('token'),
                },
            })
            .then((res) => setKpis(res.data))
            .catch((err) => console.log('No user info found', err));
    };

    useEffect(() => {
        initSellerKPI();
    }, []);

    return (
        <div className="flex flex-col gap-5">
            {/* Header */}
            <div className="rounded-xl border border-leadrs-stroke bg-white p-6">
                <div className="flex items-start gap-4">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-leadrs-purple-soft">
                        <MdAnalytics className="h-5 w-5 text-leadrs-purple-focus" />
                    </div>
                    <div>
                        <h2 className="font-crimson text-2xl font-semibold leading-tight text-leadrs-text">
                            Analytics
                        </h2>
                        <p className="mt-1 font-geist text-sm text-leadrs-text-soft">
                            Rapports détaillés et statistiques pour évaluer vos performances et ajuster vos actions.
                        </p>
                    </div>
                </div>
            </div>

            {/* KPI stats */}
            <div className="grid grid-cols-2 gap-5 xl:grid-cols-4">
                <MiniStatistics
                    name="Mes offres"
                    value={kpis ? `${kpis.totalOffers}` : '-'}
                    icon={<MdOutlineShoppingBasket className="text-leadrs-brand" />}
                    iconBg="bg-leadrs-purple-soft"
                />
                <MiniStatistics
                    name="Offres créées"
                    value={kpis ? `${kpis.createdOffers}` : '-'}
                    icon={<MdEuro className="text-leadrs-brand" />}
                    iconBg="bg-leadrs-purple-soft"
                />
                <MiniStatistics
                    name="Offres rejointes"
                    value={kpis ? `${kpis.acceptedOffers}` : '-'}
                    icon={<TbMoneybag className="text-leadrs-brand" />}
                    iconBg="bg-leadrs-purple-soft"
                />
                <MiniStatistics
                    name="Coût moyen / lead"
                    value={kpis ? `${kpis.averagePricePerOffer} €` : '-'}
                    icon={<TbPigMoney className="text-leadrs-brand" />}
                    iconBg="bg-leadrs-purple-soft"
                />
            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                <ChartBar3Period
                    title="Leads reçus"
                    data={kpis?.leadReceivedSparklineData}
                    calculateCumulativeSum={true}
                    chartTheme="green"
                />
                <ChartBar3Period
                    title="Mes offres"
                    data={kpis?.createdOrderSparklineData}
                    calculateCumulativeSum={true}
                    chartTheme="yellow"
                />
            </div>
        </div>
    );
};

export default ReportingDashboard;
